import type {
  FetchTableOrderConfigResponse,
  SaveWaitersRequest,
  SavePrintersRequest,
  UpdateTableOrderPasswordRequest,
  TableOrderActionResponse,
} from "../types/table-order-config";
import { getAuthHeaders, handleAuthError } from "./auth-api";
import { formatApiError } from "./error-message";

let baseUrl = "";
const API_PREFIX = "/api/v1";

export function setTableOrderConfigBaseUrl(url: string): void {
  baseUrl = url.replace(/\/$/, "");
}

async function postTableOrderConfig<T>(
  endpoint: string,
  data: Record<string, unknown>,
): Promise<T> {
  const url = `${baseUrl}${API_PREFIX}${endpoint}`;

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getAuthHeaders(),
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    if (response.status === 401) {
      handleAuthError();
    }
    const errorBody = await response.json().catch(() => null);
    throw new Error(
      formatApiError(errorBody, response.status, response.statusText),
    );
  }

  return response.json() as Promise<T>;
}

export async function fetchTableOrderConfig(request: {
  shopId: string;
}): Promise<FetchTableOrderConfigResponse> {
  return postTableOrderConfig<FetchTableOrderConfigResponse>(
    "/table-order-config/get",
    request,
  );
}

export async function saveTableWaiters(
  request: SaveWaitersRequest,
): Promise<TableOrderActionResponse> {
  return postTableOrderConfig<TableOrderActionResponse>(
    "/table-order-config/save-waiters",
    request as unknown as Record<string, unknown>,
  );
}

export async function saveTablePrinters(
  request: SavePrintersRequest,
): Promise<TableOrderActionResponse> {
  return postTableOrderConfig<TableOrderActionResponse>(
    "/table-order-config/save-printers",
    request as unknown as Record<string, unknown>,
  );
}

export async function updateTableOrderPassword(
  request: UpdateTableOrderPasswordRequest,
): Promise<TableOrderActionResponse> {
  return postTableOrderConfig<TableOrderActionResponse>(
    "/table-order-config/update-password",
    request as unknown as Record<string, unknown>,
  );
}
